import type { ReactElement } from 'react';
import { FlexBox } from '@ardoq/layout';
import { ArdoqIconCategory, TagIcon } from '@ardoq/icons';
import { ComponentDecoratorAsTag } from '@ardoq/basic-components';
import {
  ensureContrast,
  getTagBorderColor,
  getTagFillColor,
} from '@ardoq/color-helpers';
import { colors } from '@ardoq/design-tokens';
import type { APITagAttributes } from '@ardoq/api-types';

const TAG_BASE_COLOR = colors.blue500;
const TAG_FILL_COLOR = getTagFillColor(TAG_BASE_COLOR);
const TAG_DECORATOR_COLORS = {
  lightenedColor: TAG_FILL_COLOR,
  shadedColor: getTagBorderColor(TAG_BASE_COLOR),
  contrastColor: ensureContrast(TAG_FILL_COLOR, TAG_BASE_COLOR),
};
const NO_ICON = {
  id: '',
  label: '',
  category: ArdoqIconCategory.EDGY,
};

type PreviewTagsProps = {
  tags: APITagAttributes[];
};

export const PreviewTags = ({ tags }: PreviewTagsProps): ReactElement => (
  <FlexBox gap="small" align="center">
    <TagIcon color={colors.textSubtle} />
    <FlexBox gap="xsmall" align="center" flexWrap>
      {tags.map(tag => (
        <ComponentDecoratorAsTag
          key={tag._id}
          {...TAG_DECORATOR_COLORS}
          icon={NO_ICON}
          value=""
          isImage={false}
          label={tag.name}
          noMargin
        />
      ))}
    </FlexBox>
  </FlexBox>
);
